import { render, staticRenderFns } from "./passwordChangeForm.vue?vue&type=template&id=6d402098&scoped=true"
import script from "./passwordChangeForm.vue?vue&type=script&lang=js"
export * from "./passwordChangeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d402098",
  null
  
)

export default component.exports